import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { NodeTracker } from 'managers/nodes/tracker';
import './fluidIcon.html';
import './fluidIcon.scss';

const defaultScaleX = 0.4;
const defaultScaleY = 0.55;

export interface FluidIconVMConfig {
    icon: SubscribableOrNullableValue<string>
    staticContainer?: SubscribableOrNullableValue<boolean>
    verticalMode?: SubscribableOrNullableValue<boolean>
    showLoading?: SubscribableOrNullableValue<boolean>
    grow?: SubscribableOrNullableValue<boolean>

    scaleX?: SubscribableOrNullableValue<number>
    scaleY?: SubscribableOrNullableValue<number>
    scale?: SubscribableOrNullableValue<number>
}

@injectable()
export default class FluidIconVM {
    icon: Subscribable<string | undefined>
    showLoading: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: FluidIconVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const icon = ko.flattenComputed(config.icon);
        const isStaticContainer = ko.flattenComputed(config.staticContainer);
        const isVerticalMode = ko.flattenComputed(config.verticalMode, false);
        const showLoading = ko.flattenComputed(config.showLoading, false);

        const shouldGrow = ko.flattenComputed(config.grow, false);

        const scale = ko.flattenComputed(config.scale);
        const scaleX = ko.flattenComputed(config.scaleX).default(scale).default(defaultScaleX);
        const scaleY = ko.flattenComputed(config.scaleY).default(scale).default(defaultScaleY);

        const { width, height } = new NodeTracker({ node: info.element as HTMLElement });

        const iconSize = ko.pureComputed(() => {
            if (isVerticalMode()) {
                return height() * scaleY();
            } else if (isStaticContainer())
                return _([width() * scaleX(), height() * scaleY()]).min();
            else
                return width() * scaleX();
        });

        ko.applyBindingsToNode(info.element, {
            'css': {
                'wcc-fluid-icon': true,
                'wcc-fluid-icon--grow': shouldGrow,
                'wcc-fluid-icon--loading': showLoading
            },

            'style': {
                'font-size': iconSize.toPx()
            }
        }, this);

        this.icon = icon;
        this.showLoading = showLoading;
    }
}